// API配置和请求工具
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 获取token
const getToken = () => {
  return localStorage.getItem('token');
};

// 设置token
const setToken = (token) => {
  localStorage.setItem('token', token);
};

// 清除token
const removeToken = () => {
  localStorage.removeItem('token');
};

// 获取当前语言
const getCurrentLanguage = () => {
  return localStorage.getItem('i18nextLng') || navigator.language || 'en';
};

// 通用请求函数
const request = async (url, options = {}) => {
  const token = getToken();
  const currentLang = getCurrentLanguage();
  const headers = {
    'Content-Type': 'application/json',
    'Accept-Language': currentLang,
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers,
    });

    // 处理非JSON响应
    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      const text = await response.text();
      throw new Error(text || '请求失败');
    }

    // 处理HTTP错误状态
    if (!response.ok) {
      // 401 未授权 - 清除token并提示
      if (response.status === 401) {
        removeToken();
        localStorage.removeItem('cw_account');
        localStorage.removeItem('cw_chain');
        // 可以在这里触发重新登录
        throw new Error('登录已过期，请重新连接钱包');
      }
      
      // 403 禁止访问
      if (response.status === 403) {
        throw new Error('没有权限访问此资源');
      }
      
      // 500 服务器错误
      if (response.status >= 500) {
        throw new Error('服务器错误，请稍后重试');
      }
      
      // 其他错误
      throw new Error(data.message || data.msg || `请求失败 (${response.status})`);
    }

    return data;
  } catch (error) {
    // 网络错误
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.error('网络请求失败:', error);
      throw new Error('网络连接失败，请检查网络设置');
    }
    
    // 其他错误
    console.error('API请求错误:', error);
    throw error;
  }
};

// GET请求
export const get = (url, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const fullUrl = queryString ? `${url}?${queryString}` : url;
  return request(fullUrl, { method: 'GET' });
};

// POST请求
export const post = (url, data = null) => {
  const options = { method: 'POST' };
  if (data && typeof data === 'object') {
    options.body = JSON.stringify(data);
  }
  return request(url, options);
};

// PUT请求
export const put = (url, data) => {
  return request(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

// DELETE请求
export const del = (url) => {
  return request(url, { method: 'DELETE' });
};

// 导出工具函数
export { getToken, setToken, removeToken, API_BASE_URL };
